import { react2angular } from 'react2angular';
import EnvQueryBuilderView from '../../../../src/modules/analysis/env-query-builder/EnvQueryBuilderView.js';

angular
  .module('analysis.module')
  .component('envQueryBuilder', react2angular(EnvQueryBuilderView, ['fields', 'fieldValues', 'fieldMetadata', 'value', 'onChange', 'onValidityChange']));
